export default "__VITE_ASSET__fFMZVCWx__"